// extracted by mini-css-extract-plugin
module.exports = {"alignLeft":"TextContent_alignLeft__3wmyl"};